import { createSecuritySelectorFilter } from './helpers.ts'

/**
 * Filters out any node that does not have a **dynamicRequire** report alert.
 */
export const dynamic = createSecuritySelectorFilter(
  'dynamic',
  'dynamicRequire',
)
